import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Building, FileText, Shield, Users } from 'lucide-react';
import { Check } from 'lucide-react';

export default function CompanyFormation({ onOpenPopup }) {
  const benefits = [
    { icon: <Building className="h-6 w-6" />, title: 'Legal Structure', description: 'Establish proper business entity structure' },
    { icon: <Shield className="h-6 w-6" />, title: 'Liability Protection', description: 'Protect personal assets from business liabilities' },
    { icon: <FileText className="h-6 w-6" />, title: 'Tax Benefits', description: 'Optimize your tax structure and deductions' },
    { icon: <Users className="h-6 w-6" />, title: 'Credibility', description: 'Build trust with customers and partners' },
  ];

  const details = [
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Entity Selection', description: 'We help you choose the right business structure (LLC, Corporation, etc.) for your needs.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'State Filing', description: 'Complete preparation and filing of all formation documents with your state.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'EIN Acquisition', description: 'Obtain your federal Employer Identification Number from the IRS.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Operating Agreement', description: 'Receive customized operating agreements or bylaws for your business.' },
  ];

  const faqs = [
    { question: 'What type of business entity should I form?', answer: 'The best choice depends on your business goals, size, and tax situation. We help evaluate LLC, Corporation, and other structures.' },
    { question: 'How long does formation take?', answer: 'Most formations are completed within 7-14 business days, depending on state processing times.' },
    { question: 'What\'s included in the service?', answer: 'We handle all paperwork, state filings, EIN application, and provide operating documents for your business.' },
  ];

  return (
    <ServiceTemplate
      title="Company Formation"
      subtitle="Business Setup Services"
      description="Establish your business with professional company formation services. We handle all the paperwork and legal requirements to get your business properly structured and registered."
      heroImage="/assets/img/company-formation.webp"
      infoImage="https://images.unsplash.com/photo-1745847768380-2caeadbb3b71"
      benefits={benefits}
      details={details}
      faqs={faqs}
      onOpenPopup={onOpenPopup}
      testId="company-formation-page"
      metaTitle="Company Formation Services - LLC, Corporation Registration | Trademark Law Consulting"
      metaDescription="Professional business formation services. Form LLC, Corporation, or other entity types. Complete state filing, EIN acquisition, and operating agreements. Fast 7-14 day processing."
    />
  );
}
